/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Reminder_Custom_HintInputs */

const en_us2_profile_editors_reminder_custom_hint = /** @type {(inputs: Profile_Editors_Reminder_Custom_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You tick the days of the week`)
};

const pt_br2_profile_editors_reminder_custom_hint = /** @type {(inputs: Profile_Editors_Reminder_Custom_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você marca os dias da semana`)
};

const es_419_profile_editors_reminder_custom_hint = /** @type {(inputs: Profile_Editors_Reminder_Custom_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcas los días de la semana`)
};

const pt_pt2_profile_editors_reminder_custom_hint = /** @type {(inputs: Profile_Editors_Reminder_Custom_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcas os dias da semana`)
};

const fr_fr2_profile_editors_reminder_custom_hint = /** @type {(inputs: Profile_Editors_Reminder_Custom_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu coches les jours de la semaine`)
};

const de_de2_profile_editors_reminder_custom_hint = /** @type {(inputs: Profile_Editors_Reminder_Custom_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du wählst die Wochentage aus`)
};

const it_it2_profile_editors_reminder_custom_hint = /** @type {(inputs: Profile_Editors_Reminder_Custom_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezioni tu i giorni della settimana`)
};

/**
* | output |
* | --- |
* | "You tick the days of the week" |
*
* @param {Profile_Editors_Reminder_Custom_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_reminder_custom_hint = /** @type {((inputs?: Profile_Editors_Reminder_Custom_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Reminder_Custom_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_reminder_custom_hint(inputs)
	if (locale === "es-419") return es_419_profile_editors_reminder_custom_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_reminder_custom_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_reminder_custom_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_reminder_custom_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_reminder_custom_hint(inputs)
	return en_us2_profile_editors_reminder_custom_hint(inputs)
});
export { profile_editors_reminder_custom_hint as "profile-editors.reminder_custom_hint" }